import { useContext } from "react";
import DropCtx from "../../context";

export default function useItem(cb) {
	const {setOpen} = useContext(DropCtx);
	const onClick = ev => {
		setOpen(false);
		cb?.(ev);
	}
	return onClick;
}